<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div>
        <div class="row">
          <div class="col-md-12">
            <label>{{ $t('groupTracking.groupName') }}</label>
            <input
              readonly
              :value="record.group_name"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="row ts-mt-3">
          <div class="col-md-12">
            <label>{{ $t('groupTracking.user') }}</label>
            <div class="ts-flex ts-space-x-2">
              <a-select
                v-model.number="user_id"
                :options="userList"
                class="ts-w-full"
                showSearch
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
              <ts-button color="primary" @click.prevent="addUser">{{
                $t('add')
              }}</ts-button>
            </div>
          </div>
        </div>
        <div class="row ts-mt-8">
          <div class="col-md-12">
            <table class="ts-w-full">
              <thead>
                <tr class="ts-bg-gray-200">
                  <th class="ts-uppercase ts-px-2 ts-py-1 ts-w-3">No</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">User Name</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">Phone Number</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">Group Name</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">User Status</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1 text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(u, index) in model.users" :key="index">
                  <td class="ts-px-2 ts-py-1 ts-w-3">{{ index + 1 }}</td>
                  <td class="ts-px-2 ts-py-1">{{ u.user_name }}</td>
                  <td class="ts-px-2 ts-py-1">{{ u.phone }}</td>
                  <td class="ts-px-2 ts-py-1">{{ record.group_name }}</td>
                  <td class="ts-px-2 ts-py-1">{{ u.status }}</td>
                  <td class="text-center ts-space-x-3">
                    <a
                      href="#"
                      class="ts-text-gray-800"
                      @click.prevent="onViewMap"
                    >
                      <i class="fas fa-map-marked-alt"></i>
                    </a>
                    <a href="#" @click.prevent="deleteUser(index)">
                      <i class="fa fa-trash text-red"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { includes } from 'lodash'
export default {
  props: ['record'],
  data() {
    return {
      loading: false,
      user_id: '',
      users: [],
      model: {
        users: []
      }
    }
  },
  created() {
    this.fetchUser()
  },
  computed: {
    userList() {
      return this.users
        .filter(
          u =>
            !includes(
              this.model.users.map(el => el.user_id),
              u.user_id
            )
        )
        .map(el => ({
          value: el.user_id,
          label: el.user_name,
          ...el
        }))
    }
  },
  methods: {
    // getUser
    fetchUser() {
      this.loading = true
      this.$store
        .dispatch('sale/groupTracking/getUser')
        .then(async user => {
          this.users = user.data
          return this.fetchExisting()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchExisting() {
      return this.$store
        .dispatch('sale/groupTracking/find', this.record.id)
        .then(user => {
          this.model.users = user
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    addRemoveUser() {
      this.loading = true
      return this.$store
        .dispatch('sale/groupTracking/addUser', {
          id: this.record.id,
          data: this.model
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    addUser() {
      const user = this.users.find(u => u.user_id === this.user_id)
      if (user !== undefined) {
        this.model.users.push(user)
        this.user_id = ''
        this.addRemoveUser()
      }
    },
    deleteUser(index) {
      this.model.users.splice(index, 1)
      this.addRemoveUser()
    },
    onViewMap() {
      this.$router.push({
        name: 'group-tracking-map-view',
        query: {
          id: this.record.id
        }
      })
    }
  }
}
</script>
